module.exports = "<div class=\"c-activity__add\">\n    <button type=\"button\" class=\"c-button c-button--icon\" ng-click=\"$ctrl.addToBasket()\" ng-disabled=\"$ctrl.isDisabled()\" ng-class=\"{\n            'c-button--loading': $ctrl.basket.saving\n        }\">\n        <span class=\"c-button__text\">Add to Basket</span>\n        <span class=\"c-button__icon\">\n            <span class=\"c-button__loading\" ng-if=\"$ctrl.basket.saving\">\n                <spinner></spinner>\n            </span>\n        </span>\n    </button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/activity.add.html
// module id = 801
// module chunks = 0